import { render, staticRenderFns } from "./deal.vue?vue&type=template&id=ead2e718&scoped=true&"
var script = {}
import style0 from "./deal.vue?vue&type=style&index=0&id=ead2e718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead2e718",
  null
  
)

export default component.exports